import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { take } from 'rxjs';
import { UserDataService } from 'src/app/shared/services/user-data.service';

@Component({
  selector: 'app-body-measure',
  templateUrl: './body-measure.component.html',
  styleUrls: ['./body-measure.component.scss'],
})
export class BodyMeasureComponent {
  @Input() userUID: string | undefined;
  @Output() source = new EventEmitter();
  bodyMeasure: any;
  personal = '../../../../assets/images/measuring-tape.png';
  constructor(
    private firestore: AngularFirestore,
    private userService: UserDataService
  ) {}

  ngOnInit(): void {
    this.getPersonalInfo();
  }

  getPersonalInfo() {
    this.firestore
      .collection('bodyMeasure')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        let obj = data.data();
        obj ? (obj.firstName = obj.firstName + ' ' + obj.lastName) : '';
        this.bodyMeasure = obj;
        this.source.emit(this.bodyMeasure.bmi);
      });
  }

  calculateBMI() {
    let height = this.bodyMeasure.height;
    const inches = (height * 10) % 10;
    const feet = (height * 10 - inches) / 10;
    height = ((feet * 12 + inches) * 2.54) / 100;
    const weight = this.bodyMeasure.weight;
    const BMI = weight / (height * height);
    this.source.emit(BMI.toFixed(2));
    this.userService.setBMI(BMI.toFixed(2));
  }
}
